// extracted by mini-css-extract-plugin
module.exports = {"footer":"AddGroupPollAnswerOptionModal_footer__1P7Bq","label":"AddGroupPollAnswerOptionModal_label__2x3X8"};